import { useCallback } from 'react';
import { postData } from '../../../../../api/componentAPIs';

/**
 * Custom hook for updating hold status via API.
 * Usage:
 *   const updateHoldStatus = useUpdateHoldStatus();
 *   updateHoldStatus(params, { onSuccess, onError });
 */
export default function useUpdateHoldStatus() {
  const updateHoldStatus = useCallback(({ params, methods: { onSuccess, onError } = {} }) => {
    if (!params) {
      return;
    }
    postData('UpdateHoldStatus', params).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          onSuccess && onSuccess(response);
        } else {
          onError && onError(response);
        }
      },
      (err) => {
        onError && onError(err);
      }
    );
  }, []);

  return updateHoldStatus;
}
